import { CURRENT_ENV, ENV } from './env';
import awsconfigLocal from './workplace-cognito-config';
import awsconfigEnv from './config/env-cognito-config';

export const awsConfig = CURRENT_ENV === ENV.local ? awsconfigLocal : awsconfigEnv;
